<template >
    <div
      style="height: 100%; width: 100%; position: relative"
      class="box test-1"
    >
      <!-- <glgview /> -->
      <glgview />
      <div
        style="
          width: 100%;
          height: 80px;
          position: absolute;
          top: 0;
          text-align: center;
        "
        class="header"
      >
        <p class="title">{{ title }}</p>
        <p class="time-info">
          <span>
            <img style="margin-bottom: -3px" src="../assets/sun.png" /> &nbsp;
            {{ timeInfo.temperature }}℃ &nbsp; {{ timeInfo.weather }}
          </span>
          <span>
            {{ timeInfo.date }}&nbsp;
          </span>
          <!-- <span> <i class="el-icon-switch-button"></i> &nbsp;退出 &nbsp; </span> -->
        </p>
      </div>

      <div
        style="
          width: 23.49%;
          height: calc(100vh - 126px);
          position: absolute;
          left: 10px;
          top: 90px;
        "
      >
        <oneLeft v-if="varChangeFlag == 'null'" />
        <oneLeft v-if="varChangeFlag == 'buttonTitleO'" class="leftAnimation" />
        <twoLeft v-if="varChangeFlag == 'buttonTitleT'" class="leftAnimation" />
        <threeLeft
          v-if="varChangeFlag == 'buttonTitleTh'"
          class="leftAnimation"
        />
      </div>

      <div style="position: absolute; left: 35%; top: 90px;display:none">
        <div class="headerBox">
          <div style="flex: 4">
            <el-form
              v-if="varChangeFlag == 'buttonTitleO' || varChangeFlag == 'null'"
              style="width: 100%"
              class="headerButtonLeft-form"
            >
              <el-form-item style="width: 60%">
                <el-select
                  v-model="value1"
                  multiple
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="city in cities"
                    :label="city"
                    :value="city"
                    :key="city"
                    >{{ city }}</el-option
                  >
                </el-select>
              </el-form-item>
              <el-form-item style="width: 30%">
                <el-button
                  type="primary"
                  @click="onSubmit"
                  style="background-color: #14d7d7"
                  >查询</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div
          v-if="headerBoxMLeftShow == 'right'"
          class="headerBoxMLeft headerBoxMRight"
        >
          <div class="headerBoxMLeft-header headerBoxMRight-header" style="">
            <el-button type="text" @click="handleHeaderBoxMRight('关')"
              >关</el-button
            >
          </div>
          <div>
            <el-button type="text" @click="handleHeaderBoxMRight('开')"
              >开</el-button
            >
          </div>
        </div>
      </div>

      <div
        style="width: 43%; position: absolute; left: 28%; bottom: 35px"
        class="footerChange"
      >
        <!-- <div class="changeButton" @click="changeButton('buttonTitleO')">
          <img
            v-if="varChangeFlag == 'buttonTitleO' || varChangeFlag == 'null'"
            src="../assets/footerButtonImg.png"
          />
          <img v-else src="../assets/footerButtonImgDefault.png" />
          <span
            :class="[
              varChangeFlag == 'buttonTitleO' || varChangeFlag == 'null'
                ? 'spanStyleColor'
                : '',
            ]"
            >{{ buttonTitleO }}</span
          >
        </div> -->
        <!-- <div class="changeButton" @click="changeButton('buttonTitleT')">
          <img
            v-if="varChangeFlag == 'buttonTitleT'"
            src="../assets/footerButtonImg.png"
          />
          <img v-else src="../assets/footerButtonImgDefault.png" />
          <span
            :class="[varChangeFlag == 'buttonTitleT' ? 'spanStyleColor' : '']"
            >{{ buttonTitleT }}</span
          >
        </div> -->
        <!-- <div class="changeButton" @click="changeButton('buttonTitleTh')">
          <img
            v-if="varChangeFlag == 'buttonTitleTh'"
            src="../assets/footerButtonImg.png"
          />
          <img v-else src="../assets/footerButtonImgDefault.png" />
          <span
            :class="[varChangeFlag == 'buttonTitleTh' ? 'spanStyleColor' : '']"
            >{{ buttonTitleTh }}</span
          >
        </div> -->
      </div>

      <div
        style="
          width: 23.49%;
          height: calc(100vh - 126px);
          position: absolute;
          right: 10px;
          top: 90px;
        "
      >
        <oneRight v-if="varChangeFlag == 'null'" />
        <oneRight
          v-if="varChangeFlag == 'buttonTitleO'"
          class="rightAnimation"
        />

        <twoRight
          v-if="varChangeFlag == 'buttonTitleT'"
          class="rightAnimation"
        />
        <threeRight
          v-if="varChangeFlag == 'buttonTitleTh'"
          class="rightAnimation"
        />
      </div>
    </div>
</template>

<script>
import Vue from "vue";
import oneLeft from "@/components/oneLeft.vue";
import oneRight from "@/components/oneRight.vue";

import twoLeft from "@/components/twoLeft.vue";
import twoRight from "@/components/twoRight.vue";

import threeLeft from "@/components/threeLeft.vue";
import threeRight from "@/components/threeRight.vue";
import glgview from "./glgview.vue";

const cityOptions = ["企业", "居民", "九小场所", "单位"];
export default {
  name: "Index",
  components: {
    oneLeft,
    twoLeft,
    threeLeft,
    oneRight,
    twoRight,
    threeRight,
    glgview,
  },
  data() {
    return {
      title: "新电智慧充电平台",
      buttonTitleO: "充电全景",
      buttonTitleT: "充电安全",
      buttonTitleTh: "充电订单",
      varChangeFlag: "null",

      timeInfo: {
        date: "2023年3月8日",
        week: "一",
        h: "12",
        min: "57",
        s: "07",
        temperature: 26,
        weather: "晴",
      },
      formInline: {
        user: "",
        region: "",
      },
      value1: [],
      checkAll: false,
      checkedCities: ["门禁"],
      cities: cityOptions,
      isIndeterminate: true,
      headerBoxMLeftShow: "",
    };
  },
  methods: {
    changeButton(e) {
      this.varChangeFlag = e;
      setTimeout(() => {
        document.querySelector(".rightAnimation").style.right = 0;
        document.querySelector(".leftAnimation").style.left = 0;
      }, 1);
    },
    onSubmit() {
    },
    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
    handleHeaderBoxMShow(e) {
      if (e === this.headerBoxMLeftShow) {
        this.headerBoxMLeftShow = "";
      } else {
        this.headerBoxMLeftShow = e;
      }
    },
    handleHeaderBoxMRight(e) {
      this.$message(e);
    },
  },
  created: function () {
    // this.changeButton(this.varChangeFlag)
  },
};
</script>

<style>
@import "./styles.css";
/* @import './assets/css/b.min.css' */

.header {
  background: url("../assets/header.png");
  background-repeat: no-repeat;
  background-size: 100%;
}
</style>
